import { Input } from "@brg/input";
import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useQueryState from "shared/hooks/useQueryState";
import styled from "styled-components";

export enum FABRIC_FLOW {
    first = '1',
    second = '2',
    third = '3'
}

type TFlow = {
    label: string;
    value: string;
}

//@ts-ignore
export const fabricFlowOpts: TFlow[]  = Object.entries(FABRIC_FLOW)?.reduce((acc, [k,v]) => [...acc, { label: k, value: v }], []);

const Wrapper = styled(FlexBox)`
    .brg-input__control {
        max-width: 150px;
        background-color: #f2f2f2;
        border: none;
        border-radius: 3px;
        color: #151514;
        cursor: pointer;

        .brg-input__single-value {
            color: #151514;
            cursor: pointer;
        }

        svg path {
            fill: #151514;
            cursor: pointer;
        }
    }

    .brg-input__menu {
      background-color: #f2f2f2;
      max-width: 150px;
    }

    .brg-input__option {
        color: #151514;
        cursor: pointer;
    }
`;

const Label = styled.div`
    font-size: 17px;
    line-height: 22px;
    color: #909090;
    font-weight: 600;
`;

export const FlowDropdown: FC = () => {
    const { t } = useTranslation();
    const [{ flow }, setQueryParams] = useQueryState();

    const translatedOpts= useMemo(
        () => fabricFlowOpts?.map((i) => (
            { ...i, label: t(`competition_edit.designFabricForm.flows.label.${i.label}`)})
        )
    , [t])

    const defaultFlow = useMemo(
        () =>  !!flow ? translatedOpts?.find((i) => i?.value === flow) : 
        {  label: t(`competition_edit.designFabricForm.flows.label.first`), value: FABRIC_FLOW.first }
    , [flow, translatedOpts, t])

    const onChange = (obj: any) => {
        const isFirstFlow = obj?.value === FABRIC_FLOW.first;
        setQueryParams({ flow: isFirstFlow ? undefined : obj?.value })
    }

    return useMemo(() => (
        <Wrapper offsetBottom={24} offsetTop={24} gx={24} align="center">
            <Label>{t(`competition_edit.designFabricForm.flows.label.placeholder`)}</Label>
            <Input.Dropdown 
                value={defaultFlow}
                onChange={onChange}
                options={translatedOpts}
                placeholder={t(`competition_edit.designFabricForm.flows.label.placeholder`)}
            />
      </Wrapper>
    ) , [flow, t, translatedOpts, onChange, defaultFlow])
}import { Input } from "@brg/input";
import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useQueryState from "shared/hooks/useQueryState";
import styled from "styled-components";

export enum FABRIC_FLOW {
    first = '1',
    second = '2',
    third = '3'
}

type TFlow = {
    label: string;
    value: string;
}

//@ts-ignore
export const fabricFlowOpts: TFlow[]  = Object.entries(FABRIC_FLOW)?.reduce((acc, [k,v]) => [...acc, { label: k, value: v }], []);

const Wrapper = styled(FlexBox)`
    .brg-input__control {
        max-width: 150px;
        background-color: #f2f2f2;
        border: none;
        border-radius: 3px;
        color: #151514;
        cursor: pointer;

        .brg-input__single-value {
            color: #151514;
            cursor: pointer;
        }

        svg path {
            fill: #151514;
            cursor: pointer;
        }
    }

    .brg-input__menu {
      background-color: #f2f2f2;
      max-width: 150px;
    }

    .brg-input__option {
        color: #151514;
        cursor: pointer;
    }
`;

const Label = styled.div`
    font-size: 17px;
    line-height: 22px;
    color: #909090;
    font-weight: 600;
`;

export const FlowDropdown: FC = () => {
    const { t } = useTranslation();
    const [{ flow }, setQueryParams] = useQueryState();

    const translatedOpts= useMemo(
        () => fabricFlowOpts?.map((i) => (
            { ...i, label: t(`competition_edit.designFabricForm.flows.label.${i.label}`)})
        )
    , [t])

    const defaultFlow = useMemo(
        () =>  !!flow ? translatedOpts?.find((i) => i?.value === flow) : 
        {  label: t(`competition_edit.designFabricForm.flows.label.first`), value: FABRIC_FLOW.first }
    , [flow, translatedOpts, t])

    const onChange = (obj: any) => {
        const isFirstFlow = obj?.value === FABRIC_FLOW.first;
        setQueryParams({ flow: isFirstFlow ? undefined : obj?.value })
    }

    return useMemo(() => (
        <Wrapper offsetBottom={24} offsetTop={24} gx={24} align="center">
            <Label>{t(`competition_edit.designFabricForm.flows.label.placeholder`)}</Label>
            <Input.Dropdown 
                value={defaultFlow}
                onChange={onChange}
                options={translatedOpts}
                placeholder={t(`competition_edit.designFabricForm.flows.label.placeholder`)}
            />
      </Wrapper>
    ) , [flow, t, translatedOpts, onChange, defaultFlow])
}